module.exports = __webpack_public_path__ + "img/pw_walk_qrCode.c57154a9.png";